import React, { useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import BenefitsTable from 'components/proposal-outputs';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { useHistory } from 'react-router-dom';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import ProductOutputsPageStore, { ProductOutputsPageStoreContext } from 'store/pages/product-outputs/pageStore';
import { observer } from 'mobx-react-lite';
import { ContentWrapperStyled, DateStyled } from './styles';
import { createStyles } from '../../globalStyles';

const ProductOutputsPage: React.FC = observer(() => {
  const pageStore = useMemo(() => new ProductOutputsPageStore(), []);

  const classes = createStyles();
  const history = useHistory();

  const onBackButtonClick = (): void => {
    history.goBack();
  };

  const showCreationDate = !pageStore.isLoading && pageStore.creationDate;

  return (
    <ProposalStatusLayout>
      <ProductOutputsPageStoreContext.Provider value={pageStore}>
        <div className={classes.pageWrapper}>
          <PageHeader
            title={CARD_DATA.PRODUCT_OUTPUTS.title}
            subtitle={CARD_DATA.PRODUCT_OUTPUTS.text}
            onBackButtonClick={onBackButtonClick}
            spacing={showCreationDate ? 'withActionsBelowCompact' : 'default'}
          />
          {showCreationDate && (
            <DateStyled>{`Generated on: ${normDateToShortAmericanDate(pageStore.creationDate)}`}</DateStyled>
          )}
          <ContentWrapperStyled>
            <BenefitsTable />
          </ContentWrapperStyled>
        </div>
      </ProductOutputsPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
});

export default ProductOutputsPage;
